import PropTypes from 'prop-types';
import {useImageOptimizer} from '~/hooks/useImageOptimizer';

/* wrapper to allow useImageOptimizer hook within server components
 * returns an image tag or a div with an optimized background image
 */

export function OptimizedImageWrapper({
  imageUrl,
  elementType = 'img',
  classNames,
  imageAlt,
  anchor,
  initialWindowWidth = null,
  children,
}) {
  const optimizedImage = useImageOptimizer(imageUrl, initialWindowWidth);

  const content =
    'img' === elementType ? (
      <img
        src={optimizedImage?.optimizedImageSrc ?? ''}
        alt={imageAlt ?? ''}
        className={classNames}
        loading="lazy"
      />
    ) : 'div' === elementType ? (
      <div
        className={classNames}
        style={{
          backgroundImage: `url('${optimizedImage?.optimizedImageSrc ?? ''}')`,
        }}
      >
        {children}
      </div>
    ) : (
      <a
        className={classNames}
        href={anchor?.href}
        target={anchor?.target}
        rel={anchor?.rel}
        style={{
          backgroundImage: `url('${optimizedImage?.optimizedImageSrc ?? ''}')`,
        }}
      >
        {children}
      </a>
    );

  return content;
}

OptimizedImageWrapper.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  elementType: PropTypes.oneOf(['img', 'div', 'a']),
  classNames: PropTypes.string,
  imageAlt: PropTypes.string,
  children: PropTypes.any,
  anchor: PropTypes.object,
  initialWindowWidth: PropTypes.number,
};
